import storage from './index';
import type {ThemePreference} from './types';

export const getThemePreference = (): ThemePreference => {
	return storage.get<ThemePreference>('theme', 'light') ?? 'light';
};

export const setThemePreference = (pref: ThemePreference) => {
	storage.set('theme', pref);
};

export const getLanguagePreference = (): string | undefined =>
	storage.get<string>('language');

export const setLanguagePreference = (lang: string | undefined) => {
	if (!lang) {
		storage.remove('language');
	} else {
		storage.set('language', lang);
	}
};
